import React, { useState } from 'react';
import '../../../Assets/Css/EmploeeAddTask.scss';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import ReactDatePicker from 'react-datepicker';
import Accordion from 'react-bootstrap/Accordion';
import AddTaskModal from '../../../Components/AddTaskCategoryModal';
import AddLabelModal from '../../../Components/AddLabelModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FaUserCircle } from 'react-icons/fa';
import { addTask, addTaskCategory, addTaskLabel, deleteTaskCategory, deleteTaskLabel, getTaskCategoryList, getTaskLabelList, updateTask } from '../../../Services/Task/action';
import { getUsers } from '../../../Services/Users/action';
import { addTimesheet, updateTimesheet } from '../../../Services/TimeSheet/action';
import { connect } from 'react-redux';

const tasksCatagory = [
  { value: '--', label: '--' },
  { value: 'Daily Log', label: 'Daily Log' },
  { value: 'Design-Ui/Ux', label: 'Design-Ui/Ux' },
  { value: 'Frontend-Design', label: 'Frontend-Design' },
  { value: 'Development', label: 'Development' },
];

const Project = [
  { value: 'project1', label: 'project1' },
  { value: 'project2', label: 'project2' },
  { value: 'project3', label: 'project3' },
  { value: 'project4', label: 'project4' },
];

const Label = [
  { value: 'Project1', label: 'Project1' },
  { value: 'Project2', label: 'Project2' },
];

const Milestones = [
  { value: 'M1', label: 'M1' },
  { value: 'M2', label: 'M2' },
];

const Priority = [
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' },
]

const ProjectAssignedTo = [
  { value: "Aditi", label: "Aditi" },
  { value: "Divisha Makwana", label: "Divisha Makwana" },
  { value: "Harsh Patel", label: "Harsh Patel" },
  { value: "Hinali Narola", label: "Hinali Narola" },
  { value: "Janvi Thummar", label: "Janvi Thummar" },
  { value: "Jatin Tiwari", label: "Jatin Tiwari" },
  { value: "Kinal Makwana", label: "Kinal Makwana" },
  { value: "Kuntesh Kothiya", label: "Kuntesh Kothiya" },
  { value: "Meet Ghanva", label: "Meet Ghanva" },
  { value: "Nand Vachani", label: "Nand Vachani" },
  { value: "Raj Viradiya", label: "Raj Viradiya" },
  { value: "Rajan Vasani", label: "Rajan Vasani" },
  { value: "Tanvi Kaneriya", label: "Tanvi Kaneriya" },
];

const initialState = {
  projectstatus: { value: 'Incomplete', label: 'Incomplete', color: '#D21010' },
}

const ProjectStatus = [
  { value: 'Incomplete', label: 'Incomplete', color: '#D21010' },
  { value: 'To Do', label: 'To Do', color: '#F5C308' },
  { value: 'Doing', label: 'Doing', color: '#00B5FF' },
  { value: 'Completed', label: 'Completed', color: '#679C0D' },
  { value: 'Approved', label: 'Approved', color: '#212529' }
];

const OptionRenderer = ({ data }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FaUserCircle
        style={{
          width: '20px',
          height: '20px',
          color: '#ced4da',
          marginRight: '10px'
        }}
      />
      <span>{data.label}</span>
    </div>
  );
};

function EmploeeAddEditTask(props) {
  const [Addtaskmodal, setaddTaskModal] = useState(false);
  const [Addlabelmodal, setaddLabelModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const openTaskModal = () => setaddTaskModal(true);
  const closeTaskModal = () => setaddTaskModal(false);

  const openLabelModal = () => setaddLabelModal(true);
  const closeLabelModal = () => setaddLabelModal(false);

  const [Fields, setFields] = useState({
    Title: '',
    TaskCategory: '',
    Project: '',
    StartDate: '',
    DueDate: '',
    AssignTo: '',
    Description: '',
    label: '',
    Milestones: '',
    Priority: '',
    notes: '',
    Time: {
      hours: '',
      minutes: '',
    },
    status: [],
  });
  const [clientData, setClientData] = useState(initialState);

  return (
    <>
      <div className="TaskEmployee-main mb-5">
        <div className="page-title">
          <h4>{location.pathname == "/employees/view/task/add" ? "Add" : "Update"} Task</h4>
          <div className="edit-btn">
            <button
              type="submit"
              className="custom-btn"
              onClick={() => navigate('/employees/view/task')}
            >
              {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
              Cancel
              {/* )} */}
            </button>

            <button
              type="submit"
              className="custom-btn"
              onClick={() => navigate('/employees/view/task')}
            >
              {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
              Save
              {/* )} */}
            </button>
          </div>
        </div>

        <div className="row parent-filter m-0 p-4">
          <div className="col-lg-6 col-md-12 description ">
            <div className="input-group">
              <label className="label">Title</label>
              <input
                value={Fields.Title}
                onChange={(e) =>
                  setFields({
                    ...Fields,
                    Title: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 task-catagory">
            <div className="input-group">
              <label className="label">Task Category</label>
              <Select
                value={Fields.TaskCategory}
                onChange={(data) =>
                  setFields({
                    ...Fields,
                    TaskCategory: data,
                  })
                }
                options={tasksCatagory}
                placeholder={'options'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
            <button onClick={openTaskModal}>add</button>
          </div>
          <div className="col-lg-6 col-md-12 ">
            <div className="input-group">
              <label className="label">Project</label>
              <Select
                value={Fields.Project}
                onChange={(data) =>
                  setFields({
                    ...Fields,
                    Project: data,
                  })
                }
                options={Project}
                placeholder={'--'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-6 col-md-12 emptycomp"></div>

          <div className="col-lg-3 col-md-12">
            <div className="input-group">
              <lable className="label">Start Date</lable>
              <ReactDatePicker
                selected={Fields.StartDate}
                format="yyyy-MM-dd"
                placeholderText="Start Date"
                onChange={(date) => {
                  setFields({
                    ...Fields,
                    StartDate: date,
                  });
                }}
                className="date-picker"
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="input-group">
              <label className="label">Due Date</label>
              <ReactDatePicker
                selected={Fields.DueDate}
                format="yyyy-MM-dd"
                placeholderText="Due Date"
                onChange={(date) => {
                  setFields({
                    ...Fields,
                    DueDate: date,
                  });
                }}
                className="date-picker"
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 due_date_radio">
            <div className="radiobtn">
              <input type="checkbox" />
              <lable className="label">Without Due Date</lable>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="input-group">
              <h6 className='label'>Assigned To</h6>
              <Select
                options={ProjectAssignedTo}
                getOptionLabel={option => <OptionRenderer data={option} />}
                getOptionValue={option => option.value}
                styles={{
                  ...customStyle,
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 2,
                    width: '100%',
                  }),
                  control: (provided) => ({
                    ...provided,
                    boxShadow: 'none',
                    border: '1px solid #ced4da',
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: '#6c757d',
                  }),

                }}
                value={clientData.givenTo}
                placeholder="---"
                onChange={(selectedOptions) => {
                  setClientData((preVal) => ({
                    ...preVal,
                    givenTo: selectedOptions
                  }));
                }}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#5757fe",
                    primary: "#5757fe",
                  },
                })}
                isSearchable
                isMulti
              />
            </div>
          </div>

          <div className="col-lg-12 z-0 mb-3">
            <div className="note-part">
              <lable className="label">Description</lable>
              <div className="editor-custom">
                <CKEditor
                  editor={ClassicEditor}
                  data={Fields?.notes || ""}
                  onReady={(editor) => {
                    console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    console.log({ event, editor, data });
                    setFields({
                      ...Fields,
                      notes: data,
                    });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="parent-filter mt-4 mb-5">
        <Accordion defaultActiveKey={0}>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Other Details</Accordion.Header>
            <Accordion.Body>
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="card-type">
                    <label className="labeling task-catagory">
                      <div className="input-group">
                        <lable className="label">Label</lable>
                        <Select
                          value={Fields.label}
                          onChange={(data) =>
                            setFields({
                              ...Fields,
                              label: data,
                            })
                          }
                          options={Label}
                          placeholder={'--'}
                          styles={customStyle}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: '#5757fe',
                              primary: '#5757fe',
                            },
                          })}
                        />
                      </div>
                      <button onClick={openLabelModal}>add</button>
                    </label>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="card-type">
                    <label className="labeling">
                      <div className="input-group">
                        <h6 className="label">Milestones</h6>
                        <Select
                          value={Fields.Milestones}
                          onChange={(data) =>
                            setFields({
                              ...Fields,
                              Milestones: data,
                            })
                          }
                          options={Milestones}
                          placeholder={'--'}
                          styles={customStyle}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: '#5757fe',
                              primary: '#5757fe',
                            },
                          })}
                        />
                      </div>
                    </label>
                  </div>
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12">
                  <div className="card-type">
                    <label className="labeling">
                      <div className="input-group">
                        <lable className="label">Priority</lable>
                        <Select
                          value={Fields.Priority}
                          onChange={(data) =>
                            setFields({
                              ...Fields,
                              Priority: data,
                            })
                          }
                          options={Priority}
                          placeholder={'Medium'}
                          styles={customStyle}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: '#5757fe',
                              primary: '#5757fe',
                            },
                          })}
                        />
                      </div>
                    </label>
                  </div>
                </div>

                {location.pathname == "/employees/view/task/edit" ?
                  (
                    <>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className="card-type">
                          <label className="labeling">
                            <div className="input-group">
                              <lable className="label">Status</lable>
                              <Select
                                options={ProjectStatus}
                                styles={{
                                  ...customStyle,
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 2,
                                    width: '100%',
                                  }),
                                  control: (provided) => ({
                                    ...provided,
                                    boxShadow: 'none',
                                    border: '1px solid #ced4da',
                                  }),
                                  placeholder: (provided) => ({
                                    ...provided,
                                    color: '#6c757d',
                                  }),
                                }}
                                value={clientData.projectstatus}
                                placeholder="---"
                                onChange={(val) => {
                                  setClientData((preVal) => ({
                                    ...preVal,
                                    projectstatus: val
                                  }));
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                  },
                                })}
                                isSearchable
                                getOptionLabel={(e) => (
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span
                                      style={{
                                        height: '12px',
                                        width: '12px',
                                        backgroundColor: e.color,
                                        borderRadius: '50%',
                                        display: 'inline-block',
                                        marginRight: '10px',
                                        marginLeft: '10px'
                                      }}
                                    />
                                    {e.label}
                                  </div>
                                )}
                                getOptionValue={(e) => e.value}
                              />
                            </div>
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-8 col-md-8 col-sm-12">
                      </div>
                    </>
                  ) :
                  ("")
                }

                <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
                  <div className="radiobtn">
                    <input type="checkbox" />
                    <div className="label">Make Private</div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
                  <div className="radiobtn">
                    <input type="checkbox" />
                    <div className="label">Billable</div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 mt-4 radiobtntime">
                  <div className="radiobtn">
                    <input type="checkbox" />
                    <div className="label">Time estimate</div>
                  </div>
                  <div className="time">
                    <input
                      type="number"
                      value={Fields.Time.hours}
                      onChange={(e) =>
                        setFields({
                          ...Fields,
                          Time: {
                            ...Fields.Time,
                            hours: e.target.value,
                          },
                        })
                      }
                    />
                    <label className="label">Hrs</label>
                    <input
                      type="number"
                      value={Fields.Time.minutes}
                      onChange={(e) =>
                        setFields({
                          ...Fields,
                          Time: {
                            ...Fields.Time,
                            minutes: e.target.value,
                          },
                        })
                      }
                    />
                    <label className="label">Mins</label>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                  <div className="radiobtn">
                    <input type="checkbox" />
                    <div className="label">Repeat</div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                  <div className="radiobtn">
                    <input type="checkbox" />
                    <div className="label">Task is dependent on another task</div>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <AddTaskModal isOpen={Addtaskmodal} onClose={closeTaskModal} addTaskCategory={props?.addTaskCategory} taskCategory={props?.taskCategory} loading={props?.loading} deleteTaskCategory={props?.deleteTaskCategory} deleteLoading={props?.deleteLoading} />

      <AddLabelModal isOpen={Addlabelmodal} onClose={closeLabelModal} addTaskLabel={props?.addTaskLabel} taskLabel={props?.taskLabel} loading={props?.loading} deleteTaskLabel={props?.deleteTaskLabel} deleteLoading={props?.deleteLoading} />

    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.taskReducer.loading,
    task: state.taskReducer.shareholderslist,
    taskCategory: state.taskReducer.taskCategory,
    users: state.userReducer.users,
    deleteLoading: state.taskReducer.deleteLoading,
    taskLabel: state.taskReducer.taskLabel,
    timesheet: state.timesheetReducer.timesheet,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addTask: (data) => {
      dispatch(addTask(data));
    },
    updateTask: (id, data) => {
      dispatch(updateTask(id, data));
    },
    getUsers: () => {
      dispatch(getUsers());
    },
    addTaskCategory: (data) => {
      dispatch(addTaskCategory(data));
    },
    getTaskCategoryList: () => {
      dispatch(getTaskCategoryList());
    },
    deleteTaskCategory: (id) => {
      dispatch(deleteTaskCategory(id));
    },
    getTaskLabelList: () => {
      dispatch(getTaskLabelList());
    },
    addTaskLabel: (data) => {
      dispatch(addTaskLabel(data));
    },
    deleteTaskLabel: (id) => {
      dispatch(deleteTaskLabel(id));
    },
    addTimesheet: (data) => {
      dispatch(addTimesheet(data));
    },
    updateTimesheet: (id, data) => {
      dispatch(updateTimesheet(id, data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EmploeeAddEditTask);
